import { render, staticRenderFns } from "./AnchorageoperationsForm.vue?vue&type=template&id=72acd47e"
import script from "./AnchorageoperationsForm.vue?vue&type=script&lang=js"
export * from "./AnchorageoperationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports